/* Royalty: capa-mistério no carrinho + botões "+ Add" dos order bumps.
   - Lê #rc-gift-config (limiar, id do produto, mapa modelo -> variante).
   - Toda vez que o carrinho muda (add/change/update do tema, cupom, nossos bumps), confere:
       total >= limiar e tem capa no carrinho  -> garante 1 Mystery Case no modelo do cliente
       total <  limiar                         -> tira o Mystery Case
   - Depois de mexer, pede à Shopify as seções cart-drawer e cart-icon-bubble e troca o HTML na tela. */
(function () {
  var busy = false, again = false, self = false;

  function cfg() { var el = document.getElementById('rc-gift-config'); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function post(url, body) { self = true; return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).finally(function () { self = false; }); }

  // Modelo do cliente: primeiro iPhone que aparecer nos itens; senão o modelo de AirPods.
  function pickModel(items, c) {
    var phone = null, pods = null;
    items.forEach(function (it) {
      if (it.product_id === c.productId) return;
      (it.options_with_values || []).forEach(function (o) {
        var v = String(o.value || '').trim();
        if (!c.variants[v]) return;
        if (/^iPhone/i.test(v)) phone = phone || v; else pods = pods || v;
      });
    });
    return phone || pods;
  }

  function rerender() {
    self = true;
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var p = new DOMParser();
        var d = document.getElementById('CartDrawer');
        if (d && s['cart-drawer']) { var nd = p.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer'); if (nd) d.innerHTML = nd.innerHTML; }
        var b = document.getElementById('cart-icon-bubble');
        if (b && s['cart-icon-bubble']) { var nb = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (nb) b.innerHTML = nb.innerHTML; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer) { var ov = drawer.querySelector('#CartDrawer-Overlay'); if (ov) ov.addEventListener('click', drawer.close.bind(drawer)); var hasItems = drawer.querySelector('.cart-item'); drawer.classList.toggle('is-empty', !hasItems); }
        var wrap = document.querySelector('.cart-drawer-items-and-upsell'); if (wrap) wrap.scrollTop = 0;
      })
      .catch(function () {})
      .finally(function () { self = false; });
  }

  function sync() {
    var c = cfg(); if (!c) return Promise.resolve();
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var gifts = cart.items.filter(function (it) { return it.product_id === c.productId; });
      var others = cart.items.filter(function (it) { return it.product_id !== c.productId; });
      var want = others.length > 0 && cart.total_price >= c.threshold;
      if (want) {
        var model = pickModel(cart.items, c), vid = model ? c.variants[model] : null;
        if (!vid) return null;
        var ok = gifts.length === 1 && gifts[0].variant_id === vid && gifts[0].quantity === 1;
        if (ok) return null;
        var updates = {}; gifts.forEach(function (g) { updates[g.key] = 0; });
        var step = gifts.length ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
        return step.then(function () { return post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _rc_gift: '1' } }] }); }).then(rerender);
      }
      if (gifts.length) { var upd = {}; gifts.forEach(function (g) { upd[g.key] = 0; }); return post('/cart/update.js', { updates: upd }).then(rerender); }
      return null;
    }).catch(function () {}).finally(function () { busy = false; if (again) { again = false; sync(); } });
  }

  // qualquer mexida no carrinho feita pelo tema dispara a conferência
  var of = window.fetch;
  window.fetch = function (input, init) {
    var p = of.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!self && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function () { setTimeout(sync, 60); }, function () {});
    } catch (e) {}
    return p;
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { if (!self) setTimeout(sync, 60); }); } catch (e) {}
  }

  // "+ Add" dos order bumps (delegado, porque o HTML do carrinho é trocado inteiro)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rc-add]'); if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-rc-bump]');
    var id = btn.getAttribute('data-rc-add');
    var sel = wrap && wrap.querySelector('select[data-rc-variant]');
    if (sel) id = sel.value;
    if (!id) return;
    btn.disabled = true; btn.classList.add('is-busy');
    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      .then(function (r) { if (!r.ok) throw new Error('add'); })
      .then(rerender).then(sync)
      .catch(function () { btn.disabled = false; btn.classList.remove('is-busy'); });
  });

  // ao abrir o carrinho, a lista começa do topo (no iOS ela abria rolada e escondia o primeiro item)
  document.addEventListener('click', function (e) { if (e.target.closest('#cart-icon-bubble')) setTimeout(function () { var w = document.querySelector('.cart-drawer-items-and-upsell'); if (w) w.scrollTop = 0; }, 120); });

  // Cupom dentro do carrinho (sem ir para o checkout): aplica e remove pelo /cart/update.js e re-renderiza.
  function setDiscount(code) {
    return post('/cart/update.js', { discount: code }).then(function (r) { return r.json(); });
  }
  window.handleDiscountForm = function (e) {
    e.preventDefault();
    var form = e.target, input = form.querySelector('[name=cart-discount-field]'), err = form.querySelector('.cart-discount-form__error');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { err.textContent = 'Please enter a discount code'; err.style.display = 'block'; return; }
    var btn = form.querySelector('button'); if (btn) btn.disabled = true;
    setDiscount(code).then(function (cart) {
      var ok = (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code && d.applicable; });
      if (!ok) { setDiscount('').then(function () {}); err.textContent = 'This code is not valid for this cart'; err.style.display = 'block'; if (btn) btn.disabled = false; return; }
      return rerender().then(sync);
    }).catch(function () { err.textContent = 'Could not apply the code. Try again.'; err.style.display = 'block'; if (btn) btn.disabled = false; });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rc-discount-remove]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    try { document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'; } catch (err) {}
    setDiscount('').then(rerender).then(sync).catch(function () { b.disabled = false; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 300); }); else setTimeout(sync, 300);
})();
